"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var FullJitterBackoff_1 = require("../backoff/FullJitterBackoff");

var IntervalScheduler_1 = require("../scheduler/IntervalScheduler");

var DefaultUserAgentParser_1 = require("../useragentparser/DefaultUserAgentParser");

var Utils_1 = require("../utils/Utils");
/**
 * [[InMemoryJSONEventBuffer]] is an in-memory implementation for buffering and
 * sending events. It buffers events based on number of events and its size whichever reaches
 * first. Events are sent out at an scheduled interval where important events are sent immediately.
 * It also retries sending events if failed upto the retry count limit. It implements
 * beaconing mechanism based on 'pagehide' and 'visibilitychange' to beacon all events as a last attempt.
 */


var InMemoryJSONEventBuffer = /*#__PURE__*/function () {
  function InMemoryJSONEventBuffer(eventBufferConfiguration, eventsClientConfiguration, ingestionURL, importantEvents, logger) {
    var _this = this;

    _classCallCheck(this, InMemoryJSONEventBuffer);

    this.buffer = [];
    this.bufferSize = 0;
    this.maxBufferItemCapacityBytes = 0;
    this.ingestionEventSize = 0;
    this.flushIntervalMs = 0;
    this.flushSize = 0;
    this.failedIngestionEvents = [];
    this.retryCountLimit = 15;
    this.lock = false;
    this.cancellableEvents = new Map();
    this.attributesToFilter = ['externalUserId', 'externalMeetingId', 'timestampMs'];

    this.deepCopyCurrentIngestionEvent = function (event) {
      var newEvent = {
        type: event.type,
        v: event.v,
        payloads: _toConsumableArray(event.payloads)
      };
      return newEvent;
    };

    this.sendEvents = function () {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var batch, body, failed, timestamp, response, data, _this$failedIngestion;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.lock) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                batch = this.getItems(this.flushSize);

                if (!(batch.length === 0)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return");

              case 5:
                this.lock = true;
                body = this.makeRequestBody(batch);
                failed = false; // If a page re-directs, in Safari and Chrome, the network
                // request shows cancelled but the data reaches the ingestion endpoint.
                // In Firefox, the request errors out with 'NS_BINDING_ABORT' state. Hence, add the event
                // to cancellable events to try with `sendBeacon` lastly.

                timestamp = Date.now();

                if (this.metadata.browserName.toLowerCase() === 'firefox') {
                  this.cancellableEvents.set(timestamp, batch);
                }

                _context.prev = 10;
                this.logger.debug("Event Reporting - InMemoryJSONEventBuffer - sendEvents - sending body ".concat(body));
                _context.next = 14;
                return this.send(body);

              case 14:
                response = _context.sent;
                this.cancellableEvents.delete(timestamp);

                if (response.ok) {
                  _context.next = 21;
                  break;
                }

                this.logger.error("Event Reporting - InMemoryJSONEventBuffer - sendEvents - Failed to send events ".concat(body, " with response status ").concat(response.status));
                failed = true;
                _context.next = 31;
                break;

              case 21:
                _context.prev = 21;
                _context.next = 24;
                return response.json();

              case 24:
                data = _context.sent;
                this.logger.debug("Event Reporting - InMemoryJSONEventBuffer - sendEvents - send successful events: ".concat(body, " message: ").concat(JSON.stringify(data)));
                _context.next = 31;
                break;

              case 28:
                _context.prev = 28;
                _context.t0 = _context["catch"](21);

                /* istanbul ignore next */
                this.logger.warn("Event Reporting - InMemoryJSONEventBuffer - sendEvents error reading OK response ".concat(_context.t0, " for events ").concat(body));

              case 31:
                _context.next = 37;
                break;

              case 33:
                _context.prev = 33;
                _context.t1 = _context["catch"](10);
                failed = true;
                this.logger.warn("Event Reporting - InMemoryJSONEventBuffer - sendEvents - Error in sending events ".concat(body, " to the ingestion endpoint ").concat(_context.t1));

              case 37:
                _context.prev = 37;
                this.lock = false;
                return _context.finish(37);

              case 40:
                if (failed) {
                  this.cancellableEvents.delete(timestamp);

                  (_this$failedIngestion = this.failedIngestionEvents).push.apply(_this$failedIngestion, _toConsumableArray(batch));
                }

              case 41:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[10, 33, 37, 40], [21, 28]]);
      }));
    };

    var userAgentParserResult = new DefaultUserAgentParser_1.default(logger).getParserResult();

    var _browserMajorVersion = userAgentParserResult.browserMajorVersion,
        clientMetadata = __rest(userAgentParserResult, ["browserMajorVersion"]);

    var _a = eventsClientConfiguration.toJSON(),
        type = _a.type,
        v = _a.v,
        rest = __rest(_a, ["type", "v"]);

    this.authenticationToken = eventsClientConfiguration.getAuthenticationToken();
    this.metadata = Object.assign(Object.assign({}, clientMetadata), rest);
    Object.keys(this.metadata).forEach(function (key) {
      return _this.attributesToFilter.push(key);
    });
    this.type = type;
    this.v = v;
    this.ingestionURL = ingestionURL;
    this.logger = logger;
    this.importantEvents = new Set(importantEvents);
    var maxBufferCapacityKb = eventBufferConfiguration.maxBufferCapacityKb,
        totalBufferItems = eventBufferConfiguration.totalBufferItems,
        flushSize = eventBufferConfiguration.flushSize,
        flushIntervalMs = eventBufferConfiguration.flushIntervalMs,
        retryCountLimit = eventBufferConfiguration.retryCountLimit;
    this.maxBufferCapacityBytes = maxBufferCapacityKb * 1024;
    this.totalBufferItems = totalBufferItems;
    this.maxBufferItemCapacityBytes = Math.round(this.maxBufferCapacityBytes / totalBufferItems);
    this.flushIntervalMs = flushIntervalMs;
    this.flushSize = flushSize;
    this.retryCountLimit = retryCountLimit;
    this.currentIngestionEvent = this.initializeAndGetCurrentIngestionEvent();

    this.beaconEventListener = function (e) {
      return _this.beaconEventHandler(e);
    };

    this.addEventListeners();
  }

  _createClass(InMemoryJSONEventBuffer, [{
    key: "addEventListeners",
    value: function addEventListeners() {
      if (!this.beaconEventListener || !('window' in global) || !window.addEventListener || !('document' in global) || !document.addEventListener) {
        return;
      }

      this.logger.debug("Event Reporting - InMemoryJSONEventBuffer - addEventListeners - adding pagehide and visibility change event listeners");
      window.addEventListener('pagehide', this.beaconEventListener);
      document.addEventListener('visibilitychange', this.beaconEventListener);
    }
  }, {
    key: "beaconEventHandler",
    value: function beaconEventHandler(e) {
      /* istanbul ignore else */
      if (e.type === 'visibilitychange' && document.visibilityState === 'hidden' || e.type === 'pagehide') {
        this.logger.debug("Event Reporting - InMemoryJSONEventBuffer - beaconEventHandler is triggered calling sendBeacon");
        this.sendBeacon();
      }
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      if (!this.beaconEventListener || !('window' in global) || !window.removeEventListener || !('document' in global) || !document.removeEventListener) {
        return;
      }

      window.removeEventListener('pagehide', this.beaconEventListener);
      document.removeEventListener('visibilitychange', this.beaconEventListener);
      this.logger.debug("Event Reporting - InMemoryJSONEventBuffer - removeEventListeners - removing pagehide and visibility change event listeners");
    }
  }, {
    key: "start",
    value: function start() {
      var _this2 = this;

      var _a;

      this.removeEventListeners();
      this.addEventListeners();
      (_a = this.intervalScheduler) === null || _a === void 0 ? void 0 : _a.stop();
      this.intervalScheduler = new IntervalScheduler_1.default(this.flushIntervalMs);
      this.intervalScheduler.start(function () {
        return _this2.sendEvents();
      });
    }
  }, {
    key: "stop",
    value: function stop() {
      var _a;

      (_a = this.intervalScheduler) === null || _a === void 0 ? void 0 : _a.stop();
      this.intervalScheduler = undefined;
      this.sendBeacon();
      this.removeEventListeners();
    }
  }, {
    key: "addItem",
    value: function addItem(item) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var name, ts, attributes, filteredAttributes, event, size, currentEvent;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.logger.debug("Event Reporting - InMemoryJSONEventBuffer - addItem - received event ".concat(JSON.stringify(item)));
                name = item.name, ts = item.ts, attributes = item.attributes; // Filter out PII and redundant attributes.

                filteredAttributes = attributes && this.filterAttributes(attributes, this.attributesToFilter);
                event = Object.assign({
                  name: name,
                  ts: ts
                }, filteredAttributes);
                this.logger.debug("Event Reporting - InMemoryJSONEventBuffer - addItem - event after filtering attributes ".concat(JSON.stringify(event)));
                size = this.getSize(event);

                if (!(size > InMemoryJSONEventBuffer.MAX_ITEM_SIZE_BYTES_ALLOWED)) {
                  _context2.next = 8;
                  break;
                }

                throw new Error("Event Reporting - Item to be added has size ".concat(size, " bytes. Item cannot exceed max item size allowed of ").concat(InMemoryJSONEventBuffer.MAX_ITEM_SIZE_BYTES_ALLOWED, " bytes."));

              case 8:
                if (!this.importantEvents.has(name)) {
                  _context2.next = 12;
                  break;
                }

                // Send immediate events and asyncly retry.
                this.logger.debug("Event Reporting - InMemoryJSONEventBuffer - addItem - sending important event ".concat(JSON.stringify(event)));
                this.sendEventImmediately({
                  name: name,
                  ts: ts,
                  attributes: filteredAttributes
                });
                return _context2.abrupt("return");

              case 12:
                if (!this.isFull()) {
                  _context2.next = 15;
                  break;
                }

                this.logger.warn('Event Reporting - Event buffer is full');
                throw new Error('Buffer full');

              case 15:
                this.currentIngestionEvent.payloads.push(event);
                this.ingestionEventSize += size;

                if (this.bufferItemThresholdReached(size)) {
                  currentEvent = this.deepCopyCurrentIngestionEvent(this.currentIngestionEvent);
                  this.buffer.push(currentEvent);
                  this.bufferSize += this.ingestionEventSize;
                  this.currentIngestionEvent = this.initializeAndGetCurrentIngestionEvent();
                  this.logger.debug("Event Reporting - InMemoryJSONEventBuffer - addItem - buffer item threshold reached updated buffer ".concat(JSON.stringify(this.buffer)));
                }

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "filterAttributes",
    value: function filterAttributes(attributes, attributesToFilter) {
      var attributesToFilterSet = new Set(attributesToFilter);
      var keysToFilterOut = Object.keys(attributes).filter(function (key) {
        return attributesToFilterSet.has(key);
      });
      keysToFilterOut.forEach(function (key) {
        return delete attributes[key];
      });
      return attributes;
    }
  }, {
    key: "initializeAndGetCurrentIngestionEvent",
    value: function initializeAndGetCurrentIngestionEvent() {
      var bufferItem = {
        type: this.type,
        v: this.v,
        payloads: []
      };
      this.ingestionEventSize = this.getSize(bufferItem);
      return bufferItem;
    }
  }, {
    key: "bufferItemThresholdReached",
    value: function bufferItemThresholdReached(size) {
      return size + this.ingestionEventSize >= this.maxBufferItemCapacityBytes || this.currentIngestionEvent.payloads.length === InMemoryJSONEventBuffer.MAX_PAYLOAD_ITEMS;
    }
  }, {
    key: "getSize",
    value: function getSize(item) {
      var bytes = 0;

      if (_typeof(item) === 'object') {
        for (var _i2 = 0, _Object$entries = Object.entries(item); _i2 < _Object$entries.length; _i2++) {
          var _ref3 = _Object$entries[_i2];

          var _ref2 = _slicedToArray(_ref3, 2);

          var key = _ref2[0];
          var value = _ref2[1];
          bytes += this.getPrimitiveSize(key);
          bytes += this.getSize(value);
        }
      } else {
        bytes += this.getPrimitiveSize(item);
      }

      return bytes;
    }
  }, {
    key: "getPrimitiveSize",
    value: function getPrimitiveSize(item) {
      var bytes = 0;
      /* istanbul ignore else */

      if (typeof item === 'string') {
        bytes += item.length * 2;
      } else if (typeof item === 'number') {
        bytes += 8;
      }

      return bytes;
    }
  }, {
    key: "isFull",
    value: function isFull() {
      return this.bufferSize === this.maxBufferCapacityBytes || this.buffer.length === this.totalBufferItems;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.buffer.length === 0 || this.bufferSize === 0;
    }
  }, {
    key: "getItems",
    value: function getItems(end) {
      var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (this.isEmpty()) {
        return [];
      }

      end = Math.min(this.buffer.length, end + 1);
      var items = this.buffer.splice(start, end);
      return items;
    }
  }, {
    key: "makeBeaconRequestBody",
    value: function makeBeaconRequestBody(batchEvents) {
      var ingestionRecord = {
        metadata: this.metadata,
        events: batchEvents,
        authorization: this.authenticationToken
      };
      return JSON.stringify(ingestionRecord);
    }
  }, {
    key: "makeRequestBody",
    value: function makeRequestBody(batchEvents) {
      var ingestionRecord = {
        metadata: this.metadata,
        events: batchEvents
      };
      return JSON.stringify(ingestionRecord);
    }
  }, {
    key: "sendEventImmediately",
    value: function sendEventImmediately(item) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var name, ts, attributes, event, failed, response, body, data, _body;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.logger.debug("Event Reporting - InMemoryJSONEventBuffer - sendEventImmediately - important event received ".concat(JSON.stringify(item)));
                name = item.name, ts = item.ts, attributes = item.attributes;
                event = {
                  type: this.type,
                  v: this.v,
                  payloads: [Object.assign({
                    name: name,
                    ts: ts
                  }, attributes)]
                };
                failed = false;
                response = null;
                body = this.makeRequestBody([event]);
                _context3.prev = 6;
                _context3.next = 9;
                return this.send(body);

              case 9:
                response = _context3.sent;

                if (!response.ok) {
                  _context3.next = 24;
                  break;
                }

                _context3.prev = 11;
                _context3.next = 14;
                return response.json();

              case 14:
                data = _context3.sent;
                this.logger.debug("Event Reporting - InMemoryJSONEventBuffer - sendEventImmediately - send successful event: ".concat(body, ", message: ").concat(JSON.stringify(data)));
                _context3.next = 21;
                break;

              case 18:
                _context3.prev = 18;
                _context3.t0 = _context3["catch"](11);

                /* istanbul ignore next */
                this.logger.warn("Event Reporting - InMemoryJSONEventBuffer - sendEventImmediately - Error reading OK response ".concat(_context3.t0, " for event ").concat(body));

              case 21:
                return _context3.abrupt("return");

              case 24:
                this.logger.error("Event Reporting - InMemoryJSONEventBuffer - sendEventImmediately - Failed to send an important event ".concat(body, " with response status ").concat(response.status));
                failed = true;

              case 26:
                _context3.next = 33;
                break;

              case 28:
                _context3.prev = 28;
                _context3.t1 = _context3["catch"](6);
                this.logger.warn("Event Reporting - There may be a failure in sending an important event ".concat(body, " to the ingestion endpoint ").concat(_context3.t1, "."));
                failed = true;

                try {
                  /**
                   * Important events like meetingEnded, meetingStartFailed may result into page-redirects.
                   * In such a case, Firefox aborts the fetch request with 'NS_BINDING_ABORT' state.
                   * Chrome and Safari show fetch request as cancelled and the fetch failure is catched, but,
                   * events appear at ingestion backend. Chrome and Safari behavior is unreliable, but Firefox consistently fails,
                   * hence, we beacon data as a last resort when using Firefox.
                   * During the page-redirect, we do not have access to check fetch's response to handle Chrome and Safari behavior,
                   * hence, event ingestion may fail.
                   *
                   */
                  if (this.metadata.browserName.toLowerCase() === 'firefox') {
                    _body = this.makeBeaconRequestBody([event]);
                    this.logger.debug("Event Reporting - InMemoryJSONEventBuffer - sendEventImmediately - beaconing data out ".concat(_body));

                    if (!navigator.sendBeacon("".concat(this.ingestionURL, "?beacon=1"), _body)) {
                      failed = true;
                    } else {
                      failed = false;
                    }
                  }
                } catch (error) {
                  this.logger.warn("Event Reporting - Error sending beacon for an important event ".concat(body));
                  failed = true;
                }

              case 33:
                /* istanbul ignore else */
                if (failed) {
                  this.logger.debug("Event Reporting - InMemoryJSONEventBuffer - sendEventImmediately - pushing to failed events ".concat(body));
                  this.failedIngestionEvents.push(event);
                }

              case 34:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[6, 28], [11, 18]]);
      }));
    }
  }, {
    key: "send",
    value: function send(data) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee4() {
        var backoff, retryCount, response, backoffTime;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                backoff = new FullJitterBackoff_1.default(InMemoryJSONEventBuffer.RETRY_FIXED_BACKOFF_WAIT_MS, InMemoryJSONEventBuffer.RETRY_SHORT_BACKOFF_MS, InMemoryJSONEventBuffer.RETRY_LONG_BACKOFF_MS);
                _context4.prev = 1;
                retryCount = 0;

              case 3:
                if (!(retryCount < this.retryCountLimit)) {
                  _context4.next = 19;
                  break;
                }

                _context4.next = 6;
                return fetch(this.ingestionURL, {
                  method: 'POST',
                  headers: {
                    Authorization: "Bearer ".concat(this.authenticationToken)
                  },
                  body: data
                });

              case 6:
                response = _context4.sent;

                if (!(response.ok || !InMemoryJSONEventBuffer.SENDING_FAILURE_CODES.has(response.status))) {
                  _context4.next = 11;
                  break;
                }

                return _context4.abrupt("return", response);

              case 11:
                this.logger.warn("Will retry sending failure for ".concat(data, " due to status code ").concat(response.status, "."));
                retryCount++;
                /* istanbul ignore else */

                if (!(retryCount < this.retryCountLimit)) {
                  _context4.next = 17;
                  break;
                }

                backoffTime = backoff.nextBackoffAmountMs();
                _context4.next = 17;
                return Utils_1.wait(backoffTime);

              case 17:
                _context4.next = 3;
                break;

              case 19:
                if (!(retryCount === this.retryCountLimit)) {
                  _context4.next = 21;
                  break;
                }

                throw new Error("Retry count limit reached for ".concat(data));

              case 21:
                _context4.next = 26;
                break;

              case 23:
                _context4.prev = 23;
                _context4.t0 = _context4["catch"](1);
                throw _context4.t0;

              case 26:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[1, 23]]);
      }));
    }
  }, {
    key: "sendBeacon",
    value: function sendBeacon() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee5() {
        var _this3 = this;

        var events, clearCurrenIngestionEvent, failedRecordsCopy, beaconData;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                // Any pending events from buffer.
                events = this.buffer;
                this.logger.debug("Event Reporting - InMemoryJSONEventBuffer - sendBeacon - clearing out buffer events ".concat(JSON.stringify(events)));
                this.buffer = []; // Any pending event in current ingestion event.

                if (this.currentIngestionEvent.payloads.length > 0) {
                  clearCurrenIngestionEvent = this.deepCopyCurrentIngestionEvent(this.currentIngestionEvent);
                  events.push(clearCurrenIngestionEvent);
                  this.logger.debug("Event Reporting - InMemoryJSONEventBuffer - sendBeacon - clearing out current ingestion event ".concat(JSON.stringify(clearCurrenIngestionEvent)));
                  this.currentIngestionEvent = this.initializeAndGetCurrentIngestionEvent();
                } // Any failed ingestion events which were sent before.


                if (this.failedIngestionEvents.length > 0) {
                  failedRecordsCopy = this.failedIngestionEvents.map(function (record) {
                    return _this3.deepCopyCurrentIngestionEvent(record);
                  });
                  events.push.apply(events, _toConsumableArray(failedRecordsCopy));
                  this.logger.debug("Event Reporting - InMemoryJSONEventBuffer - sendBeacon - clearing out any failed ingestion event ".concat(JSON.stringify(failedRecordsCopy)));
                  this.failedIngestionEvents = [];
                } // Any cancelled requests due to page-redirects.


                if (this.cancellableEvents.size > 0) {
                  this.cancellableEvents.forEach(function (value) {
                    events.push.apply(events, _toConsumableArray(value));

                    _this3.logger.debug("Event Reporting - InMemoryJSONEventBuffer - sendBeacon - clearing out each cancellable event ".concat(JSON.stringify(value)));
                  });
                  this.cancellableEvents.clear();
                }

                if (!(events.length === 0)) {
                  _context5.next = 8;
                  break;
                }

                return _context5.abrupt("return");

              case 8:
                beaconData = this.makeBeaconRequestBody(events);
                this.logger.debug("Event Reporting - InMemoryJSONEventBuffer - sendBeacon - beacon data to send ".concat(beaconData));

                try {
                  /* istanbul ignore else */
                  if (!navigator.sendBeacon("".concat(this.ingestionURL, "?beacon=1"), beaconData)) {
                    this.logger.warn("Event Reporting - Browser failed to queue beacon data ".concat(beaconData));
                  }
                } catch (error) {
                  this.logger.warn("Event Reporting - Sending beacon data ".concat(beaconData, " failed with error ").concat(error));
                }

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "reset",
    value: function reset() {
      this.maxBufferCapacityBytes = 0;
      this.totalBufferItems = 0;
      this.buffer = [];
      this.bufferSize = 0;
      this.maxBufferItemCapacityBytes = 0;
      this.ingestionEventSize = 0;
      this.flushIntervalMs = 0;
      this.flushSize = 0;
      this.failedIngestionEvents = [];
      this.lock = false;
      this.beaconEventListener = undefined;
      this.cancellableEvents.clear();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee6() {
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.stop();
                this.reset();

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }]);

  return InMemoryJSONEventBuffer;
}();

exports.default = InMemoryJSONEventBuffer;
InMemoryJSONEventBuffer.SENDING_FAILURE_CODES = new Set([408, 429, 500, 502, 503, 504 // Gateway Timeout.
]);
InMemoryJSONEventBuffer.RETRY_FIXED_BACKOFF_WAIT_MS = 0;
InMemoryJSONEventBuffer.RETRY_SHORT_BACKOFF_MS = 1000;
InMemoryJSONEventBuffer.RETRY_LONG_BACKOFF_MS = 15000;
InMemoryJSONEventBuffer.MAX_PAYLOAD_ITEMS = 2;
InMemoryJSONEventBuffer.MAX_ITEM_SIZE_BYTES_ALLOWED = 3000;